import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CountryInlineListComponent } from './country-inline-list/country-inline-list.component';
import { CountryNamePipe } from './country-name.pipe';
import { CountryComponent } from './country/country.component';
import { RegionNamePipe } from './region-name.pipe';
import { RegionComponent } from './region/region.component';

@NgModule({
  declarations: [
    CountryNamePipe,
    RegionNamePipe,
    CountryComponent,
    CountryInlineListComponent,
    RegionComponent,
  ],
  imports: [CommonModule],
  exports: [
    CountryNamePipe,
    RegionNamePipe,
    CountryComponent,
    CountryInlineListComponent,
    RegionComponent,
  ],
})
export class GaGeographyModule {}
